<template>
  <v-form ref="form" @submit.prevent="changeAdmin">
    <v-layout>
      <v-flex>
        <v-text-field
          v-model="email"
          label="メールアドレス"
          :rules="[rules.required, rules.email]"
        ></v-text-field>
      </v-flex>
      <v-flex align-self-center>
        <v-btn color="warning" type="submit">
          移譲
        </v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import axios from "axios";

export default {
  props: {
    lbSubscriptionId: {
      type: String,
      default: "",
    },

    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localLbSubscriptionId: this.lbSubscriptionId,
      localChangeAdminBaseRoute: this.routes.changeAdminBaseRoute,

      email: "",

      rules: {
        required: (value) => !!value || "メールアドレスを入力してください。",
        email: (value) =>
          /.+@.+\..+/.test(value) || "メールアドレスの形式が正しくありません。",
      },
    };
  },

  methods: {
    changeAdmin() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (
        !window.confirm(
          "定額受講コンテンツのeラーニング管理権限を移譲します。よろしいですか?\n" +
            "権限を移譲すると以下の機能・情報が移行されます。\n\n" +
            "・会員解約機能\n" +
            "・決済情報",
        )
      ) {
        return;
      }

      const url = new URL(
        this.localChangeAdminBaseRoute,
        window.location.origin,
      );

      url.searchParams.append("lb_subscription_id", this.localLbSubscriptionId);
      url.searchParams.append("email", this.email);

      window.location.href = url.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: inherit;
  }
}
</style>
